import { AppData, Log, Utils } from '@lightningjs/sdk'
import { PlatformBase } from './platform-base'
import { getDeviceIp, getSiteConfig } from '../lib/models/data-service'
import { KeyCodes } from '../lib/key-codes'
import Router from '@lightningjs/sdk/src/Router'
import { AppSetup } from '../lib/app-setup'
import { PLATFORM } from '../lib/enum'
import errorHandler from '../lib/error'
import { Helper } from '../lib/helper'
import { Logger } from '../lib/logger'
import VideoScreenNew from '../pages/video-screen'

export class PlatformFireTV extends PlatformBase {

  override skipBookmarkOnDeeplink = true
  lastVisibilityState: any
  appSuspendedTime = 0
  playbackInfo: any = {
    type: "playback",
    payload: {
      state: '',
      contentId: '',
      profileId: '',
      positionMs: 0,
      durationMs: 0
    }
  }
  postMessageTimer: any = null;
  postMessageTimerInterval = 60 * 1000; // 1 minute
  constructor() {
    super()
    this._setKeys()
    this.keyMap = {
      413: 'Stop',
      415: 'Play',
      19: 'Pause',
      179: 'PlayPause',
      227: 'Rewind',
      228: 'Forward',
      33: 'Next',
      34: 'Previous',
      // 27: 'Exit',
      27: 'Back',
      73: 'Info'
    }
  }

  override setKeyMappings(appSettings: any) {
    appSettings.keys = this.keyMap
  }

  override _setKeys() {
    KeyCodes.KEY_STOP = 413;
    KeyCodes.KEY_PLAY = 415;
    KeyCodes.KEY_PAUSE = 19;
    KeyCodes.KEY_PLAYPAUSE = 179;
    KeyCodes.KEY_REWIND = 227;
    KeyCodes.KEY_FORWARD = 228;
    KeyCodes.KEY_NEXT = 33;
    KeyCodes.KEY_PREVIOUS = 34;
    KeyCodes.KEY_BACK = 27;
    KeyCodes.KEY_PLAYPAUSE = 179;
    KeyCodes.KEY_INFO = 73;
    KeyCodes.KEY_EXIT = 69;
    KeyCodes.KEY_HOME = 77;
  }

  override async initialize(): Promise<boolean> {
    this._shouldShowExitPopup = true
    // VegaOS (FireTV) - ask native for the APS bid params once, at app start. If they
    // haven't arrived by the time a bid is needed, that bid is skipped.
    if (window?.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'APS_BID_PARAMS_REQUEST' }))
    }
    Log.info('PlatformBase:', typeof this)
    const { appConfig } = AppData as AppSetup;
    this._siteConfig = await getSiteConfig()
    Log.info('PlatformBase: siteConfig: ', this._siteConfig)
    if (this._siteConfig) {
      if (this._siteConfig.ip && this._siteConfig.ip !== '') {
        this._ip = this._siteConfig.ip
      }
      if (this._siteConfig.config
        && this._siteConfig.config.enableFuse
        && this._siteConfig.config.enableFuse.siteIds
        && this._siteConfig.config.enableFuse.siteIds.length > 0) {
        const found = this._siteConfig.config.enableFuse.siteIds.find((id) => id == appConfig?.siteId);
        if (found) {
          appConfig.enableIMAAdPodding = true
        } else {
          appConfig.enableIMAAdPodding = false
        }
      } else {
        appConfig.enableIMAAdPodding = false
      }
    }
    window.onVegaMenuKey = function () {
      Log.info("FIRETV VEGA  Key: Menu key event received from Native");
      let e: KeyboardEvent;
      e = new KeyboardEvent('keydown', { key: 'Info', code: '73', keyCode: 73, isComposing: false, repeat: false });
      app.application._receiveKeydown(e)
    };
    let nativeDeviceInfo = window.nativeDeviceInfo;
    if (nativeDeviceInfo) {
      let deviceInfo = nativeDeviceInfo;//JSON.parse(nativeDeviceInfo);
      if (deviceInfo.deviceId) {
        this._deviceId = deviceInfo.deviceId;
      }
      if (deviceInfo.make) {
        this._make = deviceInfo.make;
      }
      if (deviceInfo.model) {
        this._fullModel = deviceInfo.model;
      }
    }
    let deviceId: any = Helper.urlParam('deviceId', location.search);
    if (deviceId && deviceId !== '') {
      this._deviceId = deviceId;
    }
    this.playbackInfo.payload.profileId = Helper.sha256(this._deviceId);
    let deviceType: any = Helper.urlParam('deviceType', location.search);
    if (deviceType && deviceType !== '') {
      this._fullModel = deviceType;
    }
    let deviceMake: any = Helper.urlParam('deviceMake', location.search);
    if (deviceMake && deviceMake !== '') {
      this._make = deviceMake;
    }
    let advertismentId: any = Helper.urlParam('advertismentId', location.search);
    if (advertismentId && advertismentId !== '') {
      this._ifa = advertismentId;
      Log.info('FIRETV VEGA PlatformBase: advertismentId valid ', this._ifa);
      const ifaObj = { ifa: '', ifa_type: '', lmt: '0' }
      ifaObj.ifa = advertismentId;
      ifaObj.ifa_type = '';
      ifaObj.lmt = '0';
      this.setIFADetails(ifaObj);
    }
    Log.info('FIRETV VEGA PlatformBase: _deviceId ', this._deviceId);
    Log.info('FIRETV VEGA PlatformBase: _make ', this._make);
    Log.info('FIRETV VEGA PlatformBase: _fullModel ', this._fullModel);
    Log.info('FIRETV VEGA PlatformBase: _ifa ', this._ifa);

    /*window.onDeviceInfoReceived = function (message:any) {
        console.log("Device info received in Web App:", message);
        let deviceInfo = JSON.parse(message);
        
        console.log("Device ID:", this._deviceId);
    };*/

    document.addEventListener("visibilitychange", this.handleMultiTaskingAppSwitching.bind(this));
    this.lastVisibilityState = document.visibilityState //setting the last visibility state to current visibility

    Log.info('FIRETV VEGA PlatformBase: URL ', window.location.href)
    Log.info('FIRETV VEGA PlatformBase: enableIMAAdPodding ', appConfig?.enableIMAAdPodding)
    return Promise.resolve(true);
  }

  handleMultiTaskingAppSwitching(event) {
    Log.info('visibilitychange: ', document.visibilityState)
    if (document.visibilityState === 'hidden') {
      this.handleAppSuspend()
    } if (document.visibilityState === 'visible') {
      this.handleAppResume()
    }
    this.lastVisibilityState = document.visibilityState
  }
  handleAppSuspend() {
    //on app suspended we mark current time 
    const { appState } = AppData as AppSetup;
    const route = Router.getActiveRoute()!
    const app = appState?.getApp()
    this.appSuspendedTime = new Date().getTime()
    console.log('visibilitychange: App suspended,', document.visibilityState, document.hidden, this.appSuspendedTime)
    appState.appUnload = true
    if (route.indexOf('video') > -1) {
      this.isVideoSuspended = true
      const page: VideoScreenNew = Router.getActivePage()
      app.suspendedAppStack = [...app.navigation.continuesStack]
      page.hitCloseTracker()
      page.closeVideo(true, true)
      app?.handleBackNavigation();
    }
    Logger.processUserAction('userExitedViaRemoteDirectly', 'App_Suspended')
  }

  handleAppResume() {
    const { appConfig, appState } = AppData as AppSetup;
    //on appResume we will clear 
    const timeDiff = new Date().getTime() - this.appSuspendedTime
    const wakeupTime = Helper.secondsToHms(Math.round(timeDiff / 1000), true)
    appConfig.sessionId = Helper.generateSessionId();
    Log.info('appResumed: sessionId', appConfig.sessionId)
    Logger.processUserAction('appResumedFromSuspend', 'App_Resumed_' + wakeupTime)
    this.handleResume()

  }

  async handleResume() {
    Logger.logSourceInfo(true)
    // fix for IPTV-2189
    if (this.isVideoSuspended) {
      const { appState } = AppData as AppSetup;
      const app = appState?.getApp();
      app.navigation.continuesStack = [...app.suspendedAppStack]
      app.suspendedAppStack = []
      const vodInfo = app.navigation.getCurrentVodInfo()
      if (vodInfo.actiontype == 'live') {
        Router.navigate('video-screen-live/' + vodInfo.node_id + '_resume', false)
      } else {
        Router.navigate('video-screen/' + vodInfo.node_id + '_resume', false)
      }
    }
    this.isVideoSuspended = false
  }



  override getOptionsText() {
    return 'Press Menu for Options'
  }

  /**
   * This method takes returns the url for the options icon
   * can be override but the inheritanec class.
   *
   * @param {(string|undefined)} apiOptionsIcon 
   * @returns {*} 
   */
  override getOptionsIconPath(apiOptionsIcon: string | undefined) {
    if (apiOptionsIcon && apiOptionsIcon !== '') {
      return apiOptionsIcon
    }
    return Utils.asset('/images/options_vega.png')
  }

  override isOptionsKey(e: KeyboardEvent): boolean {
    if (e.code == "73") {
      return true
    }
    return false
  }

  override sendMetrics(eventType: string, dataObj: any) {
    Log.info('Send Metrics:', eventType, dataObj)

    switch (eventType) {
      case 'close':
        Log.info('FIRETV VEGA case close')
        this.stopPostMessageTimer();
        if (window) {
          window.close()
        }
        this.postToWebView({ type: "APP_EXIT_EVENT", message: "Exit the app" });
        break;

      case 'startContent':
        /*this.updatePlaybackInfo('PLAYING', 1);
        this.postToWebView(this.getPlaybackInfo());*/
        Log.info('FIRETV VEGA case startContent')
        this.startPostMessageTimer();
        break;

      case 'stopContent':
        Log.info('FIRETV VEGA case stopContent')
        this.updatePlaybackInfo('EXIT', dataObj.watchedDuration);
        this.postToWebView(this.getPlaybackInfo());
        this.stopPostMessageTimer();
        break;

      case 'pauseContent':
        Log.info('FIRETV VEGA case pauseContent')
        this.updatePlaybackInfo('PAUSED', dataObj.watchedDuration);
        this.postToWebView(this.getPlaybackInfo());
        break;

      case 'resumeContent':
        Log.info('FIRETV VEGA case resumeContent')
        this.updatePlaybackInfo('PLAYING', dataObj.watchedDuration);
        this.postToWebView(this.getPlaybackInfo());
        break;

      case 'adBreakStart':
        Log.info('FIRETV VEGA case adBreakStart')
        this.updatePlaybackInfo('INTERSTITIAL', dataObj.watchedDuration);
        this.postToWebView(this.getPlaybackInfo());
        break;

      case 'adBreakEnd':
        Log.info('FIRETV VEGA case adBreakEnd')
        this.updatePlaybackInfo('PLAYING', dataObj.watchedDuration);
        this.postToWebView(this.getPlaybackInfo());
        break;
    }
  }

  /*override async getPlatformDeeplinkData(): Promise<string> {
      return new Promise((resolve, reject) => {
        let playIdFromQuery: any = Helper.urlParam('playId', location.search);
        let playIdFromParams = ''
        let isValidDeeplinkParams = false
        let navigationAssetId = ''
        
        if (isValidDeeplinkParams) {
          playIdFromParams = navigationAssetId
          Logger.processUserAction('deeplinkRawDataFromPlatform', JSON.stringify(this._params))
          Log.info('DeeplinkRawDataFromPlatform:', this._params)
          resolve(`?playId=${playIdFromParams}&src=hs-search`)
        } else if (!Helper.isEmpty(playIdFromQuery)) {
          Logger.processUserAction('deeplinkRawDataFromQueryString', playIdFromQuery)
          Log.info('DeeplinkRawDataFromQueryString:', playIdFromQuery)
          // fallback to the query string
          resolve(`?playId=${playIdFromQuery}&src=hs-search`)
        } else {
          resolve('')
        }
      })
    }*/

  override getPlatformDeeplinkData(contentChangeUrl?: string): Promise<string> {
    return new Promise((resolve, reject) => {
      if (!contentChangeUrl) {
        contentChangeUrl = location.search
      }
      const playId = Helper.getIptvParameterFromUrl('playId', contentChangeUrl);
      const searchKeys = Helper.getIptvParameterFromUrl('searchKeys', contentChangeUrl);

      let deeplinks: any = {}

      if (playId !== undefined && playId !== '') {
        deeplinks.sourceType = 'hs-d';
        deeplinks.playId = playId;
        resolve(`?playId=${deeplinks.playId}&src=${deeplinks.sourceType}`)
      } else if (searchKeys !== undefined && searchKeys !== '') {
        deeplinks.sourceType = 'hs-search';
        deeplinks.playId = playId;
        resolve(`?${contentChangeUrl?.split('?')[1]}`)
      } else {
        resolve('')
      }
    })
  }

  override getSlot(context: string) {
    return `SlotId_${context}`
  }
  override requestApsBid(apsBid: any, key: string, context: string, vodInfo: any) {
    return apsBid.request(key, context, vodInfo)
  }
  override waitApsBid(apsBid: any, key: string) {
    return apsBid.wait(key)
  }
  override getAppStoreUrlMacro(): string {
    const storeId: any = Helper.urlParam('storeId', location.search);
    return `https://www.amazon.com/dp/${storeId}`
  }
  override getAppStoreId(type = ''): string {
    let storeId: any = Helper.urlParam('storeId', location.search);
    return storeId;
  }
  override getDeviceOSVersion() {
    let osVersion: any = Helper.urlParam('osVersion', location.search);
    return osVersion;
  }

  override getCountry() {
    const { appState } = AppData as AppSetup;
    return appState?.getAppApiConfig()?.userConfig?.countryCode || ''
  }

  /**
   * Updates the playback information payload.
   *
   * @param {string} state - Current playback state (e.g., 'PLAYING', 'PAUSED', 'STOPPED').
   * @param {number} position - Current playback position in seconds.
   *
   * This method:
   * - Fetches current VOD information
   * - Determines whether content is Episode or Movie
   * - Updates playback payload fields
   * - Converts seconds to milliseconds
   */
  override updatePlaybackInfo(state: string, position: any) {
    //Log.info('FIRETV VEGA Updating playback info: state=', state, 'position=', position);
    const { appState } = AppData as AppSetup;
    const app = appState?.getApp();
    const vodInfo = app?.navigation.getCurrentVodInfo()
    const isEpisode = vodInfo && vodInfo.episode && vodInfo.series_name && vodInfo.season;
    const contentId = `${isEpisode ? 'FTEPISODE' : 'FT'}-${vodInfo?.node_id}`;
    this.playbackInfo.payload.state = (state) ? state.toUpperCase() : '';
    this.playbackInfo.payload.contentId = contentId;
    this.playbackInfo.payload.positionMs = position ? Math.round(position * 1000) : 1 * 1000;
    this.playbackInfo.payload.durationMs = vodInfo?.runtime ? vodInfo.runtime * 1000 : 0;
  }

  /**
   * Sends payload data to React Native WebView.
   *
   * @param {Object} payload - The data object to be posted.
   *
   * Safely stringifies and posts message if WebView is available.
   */
  postToWebView(payload: any) {
    Log.info(`${this.getCurrentTimestamp()} : FIRETV VEGA Posting Message: state ${this.playbackInfo.payload.state} : positionMs ${this.playbackInfo.payload.positionMs} : payload : ${payload}`);
    try {
      if (window?.ReactNativeWebView && payload) {
        window.ReactNativeWebView.postMessage(JSON.stringify(payload));
      }
    } catch (e) {
    }
  }

  /**
   * Returns the current playback information object.
   *
   * @returns {Object} playbackInfo - Current playback payload object.
   */
  getPlaybackInfo() {
    return this.playbackInfo;
  }

  /**
   * Starts a timer that sends playback info
   * to WebView every 60 seconds.
   *
   * Prevents multiple timers from running simultaneously.
   */
  startPostMessageTimer() {
    // Prevent multiple timers
    if (this.postMessageTimer) return;

    this.postMessageTimer = setInterval(() => {
      this.postToWebView(this.getPlaybackInfo());
    }, this.postMessageTimerInterval); // 1 minute
  }

  /**
   * Stops the active post message timer.
   *
   * Clears the interval and resets the timer reference.
   */
  stopPostMessageTimer() {
    if (this.postMessageTimer) {
      clearInterval(this.postMessageTimer);
      this.postMessageTimer = null;
    }
  }

  /**
   * Utility method to get the current time in HH:MM:SS:MS format.
   *
   * @returns {string} Formatted current time string.
   */
  getCurrentTimestamp() {
    var now = new Date();

    var hours = now.getHours();
    var minutes = now.getMinutes();
    var seconds = now.getSeconds();
    var milliseconds = now.getMilliseconds();

    // Add leading zeros
    if (hours < 10) hours = "0" + hours;
    if (minutes < 10) minutes = "0" + minutes;
    if (seconds < 10) seconds = "0" + seconds;

    // Ensure milliseconds is 3 digits
    if (milliseconds < 10) {
      milliseconds = "00" + milliseconds;
    } else if (milliseconds < 100) {
      milliseconds = "0" + milliseconds;
    }

    return hours + ":" + minutes + ":" + seconds + ":" + milliseconds;
  }
}
